module.exports = __webpack_public_path__ + "static/media/planning-icon.f5e0883d.svg";